import { render, staticRenderFns } from "./EdiAccountCreate.vue?vue&type=template&id=42d4c78a&"
import script from "./EdiAccountCreate.vue?vue&type=script&lang=js&"
export * from "./EdiAccountCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports